module.exports = __webpack_public_path__ + "img/case_sundata_wide.c049e7b2.jpg";